import { useEffect } from "react";
import { isErrorMessage } from "@sscs/types";
import { useLoginInfo } from "Hooks";
import { useEmailConfirmationMutation } from "../services/passwordReset.api";

type UseEmailConfirmation = {
  hasConfirmationFailed: boolean;
  isConfirmed: boolean;
  isConfirming: boolean;
  error: string;
};

const useEmailConfirmation = (
  verificationToken?: string,
): UseEmailConfirmation => {
  const { isInFlight, hasLoaded, isSSOLogin } = useLoginInfo();

  const [
    confirmEmail,
    {
      isLoading: isConfirming,
      isSuccess: isConfirmed,
      isError: hasConfirmationFailed,
      error,
    },
  ] = useEmailConfirmationMutation();

  useEffect(() => {
    confirmEmail({
      body: {
        verification_token: verificationToken ?? "",
      },
    })
      .unwrap()
      .catch(() => null); // error is handled via query status
  }, [verificationToken, confirmEmail]);

  return {
    hasConfirmationFailed,
    isConfirmed: isConfirmed && hasLoaded,
    isConfirming: isConfirming && isInFlight,
    error:
      isErrorMessage(error) && isSSOLogin // I really only want this error for SSO related issues and fallback otherwise
        ? error.data.error
        : 'You can still use "Forgot my password" to reset your password and activate your account',
  };
};

export default useEmailConfirmation;
